import React from 'react';
import { CheckboxField, Tooltip } from '@hoffmann/pattern-library-2';
import styles from './ContactForm.module.scss';

interface Props {
  children: any;
  checked: boolean;
  error?: string;
  onChange: (value: boolean) => void;
}

export const Checkbox = React.forwardRef<HTMLInputElement, Props>(
  ({ children, checked, onChange, error }, ref) => {
    const handleChange = (value: boolean) => {
      onChange(value);
    };

    return (
      <div className={`${styles.checkboxComponent} ${error ? styles.checkboxError : ''}`}>
        <div>
          <CheckboxField ref={ref} label="" checked={checked} onChange={handleChange} />
        </div>
        {error && (
          <Tooltip content={error} preventTabbing>
            <div
              className={`${styles.checkboxLabel} ${styles.checkboxError}`}
              onClick={() => handleChange(!checked)}
            >
              {children}
            </div>
          </Tooltip>
        )}
        {!error && (
          <div className={styles.checkboxLabel} onClick={() => handleChange(!checked)}>
            {children}
          </div>
        )}
      </div>
    );
    // });
  },
);
